/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class ManageProcessDataConfigurationService extends DataService<Wars.Domain.Model.ManageProcessDataConfiguration> {
        public createProcessDataViewConfiguration(): Wars.Domain.Model.ProcessDataViewConfiguration {
            return <Wars.Domain.Model.ProcessDataViewConfiguration>this.createNewEntity("ProcessDataViewConfiguration");
        }
        public createManageProcessDataConfiguration(): Wars.Domain.Model.ManageProcessDataConfiguration {
            return <Wars.Domain.Model.ManageProcessDataConfiguration>this.createNewEntity("ManageProcessDataConfiguration");
        }
        public createManageProcessEventConfiguration(): Wars.Domain.Model.ManageProcessEventConfiguration {
            return <Wars.Domain.Model.ManageProcessEventConfiguration>this.createNewEntity("ManageProcessEventConfiguration");
        }
    }
}
warsApp.registerService('ManageProcessDataConfigurationService', ['breeze', '$q']);